/**
 * @generated SignedSource<<9547f9032872eb0e4a75c7bd89cdb81a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicSponsorArticlesQueueQuery$data = {
  readonly sponsorArticlesQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
        };
      }>;
    } | null;
  } | null;
  readonly " $fragmentType": "topicSponsorArticlesQueueQuery";
};
export type topicSponsorArticlesQueueQuery$key = {
  readonly " $data"?: topicSponsorArticlesQueueQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicSponsorArticlesQueueQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sponsorArticleQueueName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicSponsorArticlesQueueQuery",
  "selections": [
    {
      "alias": "sponsorArticlesQueue",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "sponsorArticleQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 20
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityId",
                          "storageKey": null
                        }
                      ],
                      "type": "Base",
                      "abstractKey": "__isBase"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "contentItemRenderContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:20)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "388fad8582570a77d7f2be37aadc77da";

export default node;
